/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Descargar Bumble",
      "Aceptar todas",
      "Administrar opciones",
      "Política de Cookies",
      "Atrás",
      "Número de celular incorrecto",
      "@{{current_year}}Bumble | Todos los derechos reservados",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Acerca de",
      "Embajadores",
      "Blog",
      "Esta página utiliza cookies. Si no deseas ajustar tu configuración, asumiremos que estás de acuerdo con el uso de las cookies.",
      "Descargar la aplicación",
      "Descargar para Android",
      "Descargar para iOS",
      "Lo sentimos, pero no pudimos encontrar la página que estabas buscando.",
      "Entrar",
      "Únete",
      "¡Únete a la Colmena!",
      "Parece que algo falló..."
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
